<template>
  <div>
    <menubar :permission="permission" />
    <div class="container-fluid">
      <Title title="動画翻訳" style="margin-bottom: 1rem;" />
      <span v-if="prohibitEdit">
        {{editingUser}}が編集中のため編集不可
      </span>
      <div class="d-flex justify-content-end">
        <el-button v-if="!isShowCreate" style="margin-left:2rem;" type="danger" :onClick="closePage"
          size="large">閉じる</el-button>
        <el-button v-if="!isShowCreate" style="margin-right: 2rem;" type="primary" :onClick="saveCaptions" size="large"
          :disabled="prohibitEdit">保存</el-button>

        <!-- ダウンロードモーダル -->
        <div v-if="!isShowCreate">
          <el-icon v-show="!prohibitEdit && !hiddenSettingIcon" :size="30" @click="openDownloadModal(this.videoTranslateId, this.subtitleEmbedStatus, this.subtitleEmbeddedAt)">
            <Download />
          </el-icon>
          <DownloadModal ref="downloadModal"
               :downloadTypes="downloadTypes"
               :downloadVideoId="downloadVideoId"
               v-on:isGotoDownload="isGotoDownload = $event" />
        </div>

        <!-- 字幕焼付設定モーダル -->
        <modal ref="subtitleSettingModal" v-if="!isShowCreate" :onClose="canselSubtitleInfo">
          <template v-slot:activator="{ openModal }">
            <el-icon v-show="!prohibitEdit && !hiddenSettingIcon" :size="30" @click="openModal();">
              <EditPen />
            </el-icon>
          </template>
          <!--モーダルタイトル-->
          <template v-slot:modalTitle>
            <span>字幕焼付オプション</span>
          </template>
          <!--モーダル内のコンテツ-->
          <template v-slot:modal-content="{ closeModal }">
            <label class="form-label">書き起こし(原文)の有無</label>
            <div style="display: flex; align-items: center;">
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" name="srcVisibility" value="表示" v-model="modalTitleSetting.srcVisibility">
                <label class="form-check-label">表示</label>
              </div>
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" name="srcVisibility" value="非表示" v-model="modalTitleSetting.srcVisibility">非表示
              </div>
            </div>
            <label class="form-label">字幕(翻訳文)表示位置</label>
            <div style="display: flex; align-items: center;">
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" name="trgPosition" value="下部" v-model="modalTitleSetting.trgPosition">
                <label class="form-check-label">下部</label>
              </div>
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" name="trgPosition" value="上部" v-model="modalTitleSetting.trgPosition">
                <label class="form-check-label">上部</label>
              </div>
            </div>
            <!-- ボタン -->
            <div class="modal-btn d-flex justify-content-evenly">
              <div>
                <button class="btn btn-red" @click="closeModal()">キャンセル</button>
              </div>
              <div>
                <button class="btn btn-purple">
                  <span @click="updateSubtitleInfo(closeModal)" >更新</span>
                </button>
              </div>
            </div>
          </template>
        </modal>

        <modal ref="videoSettingModal">
          <template v-slot:activator="{ openModal }">
            <el-icon v-show="!prohibitEdit && !hiddenSettingIcon" :size="30" @click="openModal();">
              <Setting />
            </el-icon>
          </template>
          <!--モーダルタイトル-->
          <template v-slot:modalTitle>
            <span v-if="isShowCreate">動画のインポート</span>
            <span v-else>用語集・AIモデルの変更</span>
          </template>
          <!--モーダル内のコンテツ-->
          <template v-slot:modal-content="{ closeModal }">
            <div class="mb-4" v-if="isShowCreate">
              <label class="form-label">動画・音声ファイルをアップロード　※動画上限：{{ form.validation.maxUploadSize.filesizeByte / (1024 ** 3) }}GB、{{ form.validation.maxUploadSize.durationSecond / 3600 }}時間｜対応拡張子：mp4, m4v, mpeg, mpg, mp3, m4a, wav｜対応コーデック：H.264, MPEG-1, MPEG-2</label><br />
              <div class="form-control d-flex" style="padding:0">
                <label for="video_file_upload" class="filelabel">ファイル選択</label>
                <input type="file" id="video_file_upload" class="d-none" ref="file" accept="video/mp4,video/x-m4v,video/mpeg,audio/mp3,audio/x-m4a,audio/wav"
                  v-on:change="changeVideoFile($event)" />
                <div style="  width: 80%; padding: 5px; background: #fff; color: #666;">
                  {{ form.videoFileName }}
                </div>
              </div>
            </div>
            <div class="mb-4" v-if="isShowCreate">
              <label class="form-label">動画の言語</label><br />
              <div style="  display: flex; align-items: center;">
                <select class="lang-pair-select" v-model="form.videoLanguage" @change="updateTranslationResources()">
                  <option v-for="(lang, index) in videoLanguages" :key="index" :value="lang.value" ref="srcLanguage">
                    {{ lang.name }}
                  </option>
                </select>
              </div>
            </div>

            <div class="mb-4" v-if="isShowCreate">
              <label class="form-label">翻訳機能について</label>
              <div style="  display: flex; align-items: center;">
                <select class="lang-pair-select" v-model="form.srcInputMethod">
                  <option v-for="(type, index) in translateTypeList" :key="index" :value="type.value">
                    {{ type.text }}
                  </option>
                </select>
              </div>

              <div class="form-control d-flex mb-4" v-if="form.srcInputMethod === 'import'"
                style="padding:0;margin-top: 0.5rem;">
                <label for="transcription_file_upload" class="filelabel">ファイル選択</label>
                <input type="file" id="transcription_file_upload" class="d-none" ref="file"
                  v-on:change="changeTranscriptFile($event)" :disabled="form.srcInputMethod != 'import'" />
                <div style="  width: 80%; padding: 5px; background: #fff; color: #666;">
                  {{ form.transcriptFileName }}
                </div>
              </div>
            </div>
            <div class="mb-4" v-show="!isShowCreate || useTranslateFeature">
              <label class="form-label">翻訳先言語</label>
              <div style="  display: flex; align-items: center;">
                <select class="lang-pair-select" v-model="form.trgLanguageCode" @change="updateTranslationResources()">
                  <option v-for="( language, index ) in  translationLanguages " :key="index" :value="language.code"
                    ref="trgLanguage">
                    {{ language.name }}
                  </option>
                </select>
              </div>
            </div>

            <div class="mb-4" v-if="!isShowCreate || useTranslateFeature">
              <label class="form-label">用語集</label>
              <div style="  display: flex; align-items: center;">
                <select class="lang-pair-select" v-model="form.glossaryId">
                  <option label="指定しない" value="" selected></option>
                  <option v-for="( glossary, index ) in  formGlossaries " :key="index" :value="glossary.id">
                    {{ glossary.name }}
                  </option>
                </select>
              </div>
            </div>

            <div class="mb-4" v-if="!isShowCreate || useTranslateFeature">
              <label class="form-label">AIモデル</label>
              <div style="  display: flex; align-items: center;">
                <select class="lang-pair-select" v-model="form.aimodelId">
                  <option v-for="( aimodel, index ) in  formAimodels " :key="index" :value="aimodel.id">
                    {{ aimodel.name }}
                  </option>
                </select>
              </div>
            </div>


            <div class="modal-btn d-flex justify-content-evenly">
              <div>
                <button class="btn btn-red" @click="closeModal()">キャンセル</button>
              </div>
              <div>
                <button class="btn btn-purple">
                  <span @click="uploadVideoFile()" v-if="isShowCreate">アップロード</span>
                  <span @click="updateVideoInfo()" v-else>更新</span>
                </button>
              </div>
            </div>
          </template>
        </modal>
      </div>

      <div class="row">
        <div class="col-12" style="width:100vw;">
          <div v-show="videoSource && videoLoaded" id="column"
            style="display: flex; flex-direction: row; margin-top: 1rem; margin-bottom : 1.5rem;">
            <div id="primary" v-show="videoSource">
              <div style="max-height: 100%; text-align: center;">
                <video id="video" ref="video" controls preload="auto">
                  <source ref="videoSource" :src="videoSource" :type="videoMimeType || undefined" />
                </video>
              </div>
              <div id="flex-container" style="position:relative; display: flex;  justify-content: space-around;">
                <div style="text-align: center;">
                  <img @click="changeVideoTime(-0.03)" src="/img/back-forward.svg" alt="" width="60">

                  <img v-if="this.video !== undefined && videoIsPaused" @click="toggleVideoPlayback()" width="60"
                    src="/img/play-video.svg" alt="">
                  <img v-if="this.video !== undefined && !videoIsPaused" @click="toggleVideoPlayback()" width="60"
                    src="/img/stop-video.svg" alt="">

                  <img @click="changeVideoTime(0.03)" src="/img/fast-forward.svg" alt="" width="60">
                </div>
                <div style="display: inline-block; text-align: center;">
                  <div v-if="toShowVideoCurrentTime !== undefined"
                    style="background: white; display: inline-block; padding:0.2rem 0.5rem; border-radius: 1rem; font-size:1.5rem; ">
                    TC : {{ this.timeCode }}
                  </div>
                </div>
              </div>
            </div>
            <div id="secondary">
              <div v-for="( caption, index ) in  captionResult "
                @click="coloringBackGround($event); changeWaveCurrentTime(index)">
                <div class="d-flex flex-row div__caption">
                  <div class="border__ flex-fill">
                    <div class="div__caption--header d-flex" style="padding-left: 1rem; text-align: right;"
                      v-if="caption.startTimes">
                      <span style="color:white; margin-right: auto;">{{ index + 1 }}</span>
                      <span style="display: inline-block; margin-right: 1rem;">
                        <span style="color:white;padding-right: 0.5rem;">IN</span>
                        <input type="number" class="input__number no-spin" :min="-1" :max="100" :data-key="index"
                          v-model.lazy="caption.startTimes.hour" :disabled="prohibitEdit" /> :
                        <input type="number" class="input__number no-spin" :min="-1" :max="60" :data-key="index"
                          v-model.lazy="caption.startTimes.minute" :disabled="prohibitEdit" /> :
                        <input type="number" class="input__number no-spin" :min="-1" :max="60" :data-key="index"
                          v-model.lazy="caption.startTimes.second" :disabled="prohibitEdit" /> :
                        <input type="number" class="input__number no-spin" style="width:30px;" :min="-1" :max="1000"
                          :data-key="index" v-model.lazy="caption.startTimes.millisecond" :step="1" :disabled="prohibitEdit" />
                      </span>
                    </div>
                    <div>
                      <textarea class="textarea__caption" name="" id="" cols="30" rows="3"
                        style="margin:0 auto; width: 100%; height:100%;display: block;" v-model="caption.src"
                        :date-key="index" :disabled="prohibitEdit"></textarea>
                    </div>
                  </div>
                  <div class="border__ flex-fill">
                    <div class="div__caption--header" v-if="caption.endTimes">
                      <span style="color:white;padding-left:0.25rem;padding-right: 0.5rem;">OUT</span>
                      <input type="number" class="input__number no-spin" :min="-1" :max="100" :data-key="index"
                        v-model.lazy="caption.endTimes.hour" :disabled="prohibitEdit" /> :
                      <input type="number" class="input__number no-spin" :min="-1" :max="60" :data-key="index"
                        v-model.lazy="caption.endTimes.minute" :disabled="prohibitEdit" /> :
                      <input type="number" class="input__number no-spin" :min="-1" :max="60" :data-key="index"
                        v-model.lazy="caption.endTimes.second" :disabled="prohibitEdit" /> :
                      <input type="number" class="input__number no-spin" style="width:30px;" :min="-1" :max="1000"
                        :data-key="index" v-model.lazy="caption.endTimes.millisecond" :step="1" :disabled="prohibitEdit" />
                      <el-icon v-show="!prohibitEdit" color="white" :size="15" class="more__icon"
                        @click="showContextMenu(caption.id, $event)">
                        <MoreFilled />
                      </el-icon>
                    </div>
                    <div v-if="caption.trg !== undefined">
                      <textarea class="textarea__caption" name="" id="" cols="30" rows="3"
                        style="margin:0 auto; width: 100%; height:100%;display: block;" v-model="caption.trg"
                        :date-key="index" :disabled="prohibitEdit"></textarea>
                    </div>
                    <div v-else>字幕なし</div>
                  </div>
                </div>
              </div>
              <ContextMenu ref="contextMenu" v-if="captionResult" :caption="captionResult"
                @update="handleCaptionUpdate" />
            </div>
          </div>
          <div v-show="videoSource && videoLoaded" class="div__waveform">
            <!-- <label style="margin-left: 2em"> Zoom: <input type="range" min="0" max="1000" value="0" step="100" /> </label> -->

            <div style="display: flex">
              <div id="div__waveform_zoom" style="width:10%; display:inline-block;">
                <el-icon :size="40" color="#FFFFFF"
                  style="background-color: rgb(111,66,201); border-radius: 50%; display:block; margin: 1rem auto;"
                  @click="zoomWaveSurfer(100)">
                  <Plus />
                </el-icon>

                <el-icon :size="40" color="#FFFFFF"
                  style="background-color: rgb(111,66,201); border-radius: 50%;display:block; margin: 1rem auto 2rem;"
                  @click="zoomWaveSurfer(-100)">
                  <Minus />
                </el-icon>
              </div>
              <div style="width:90%">
                <div class="div__Numbering" id="Numbering--id" style="overflow-x: hidden;">
                  <div class="Numbering" id="div__Numbering--id"
                    style="display:flex; background-color:rgba(220,220,229); margin-bottom: 0.5rem;"
                    :style="{ 'width': scaleWidth + 'px' }">
                    <div class="number" v-for="(   caption, index   ) in    captionResult   "
                      :style="{ 'margin-left': captionLeftMargin(caption) + 'px', width: captionLength(caption) + 'px' }">
                      {{ index + 1 }}
                    </div>
                  </div>
                </div>
                <div id="waveform" style="width:100%; display:inline-block;" @scroll="syncScroll"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footerComponent />
  </div>
</template>

<script lang="js">
import axios from 'axios';

import { UploadFilled, MoreFilled, Plus, Minus, VideoPlay, VideoPause, Setting, EditPen, Download } from '@element-plus/icons-vue';
import { ElLoading, ElMessage, ElMessageBox } from 'element-plus';

import WaveSurfer from 'wavesurfer.js';
import RegionsPlugin from 'wavesurfer.js/dist/plugins/regions';
import TranslationOptions from '@/Pages/Components/TranslationOptions.vue';
import ContextMenu from '@/Pages/Components/contextMenu.vue';
import modal from '@/Pages/Components/modal.vue';
import DownloadModal from '../../Components/DownloadModal.vue';
import menubar from '@/Pages/Common/menu.vue';
import footerComponent from '@/Pages/Components/footer.vue';
import Title from '@/Pages/Components/Title.vue';
import Decimal from 'decimal.js';

import { FFmpeg } from "@ffmpeg/ffmpeg";
import { fetchFile } from '@ffmpeg/util';
import { reactive } from "vue";
import { Inertia } from '@inertiajs/inertia'

export default {
  name: 'video-index',
  props: {
    videoTranslateId: String,

    videoSourceUrl: String,
    videoLanguages: Array,
    translationLanguages: Array,
    glossaries: Array,
    aimodels: Array,
    translateTypeList: Array,
    isEditingByMe: Boolean,
    editingUser: String,

    captions: Array,
    // 以下の変数はモーダルで使用
    validation: Object,
    videoLanguage: String,
    glossaryId: String,
    aimodelId: String,
    srcLanguageCode: String,
    trgLanguageCode: String,

    // ダウンロードモーダルで使用
    downloadTypes: Array,
    subtitleSrcVisibility: String,
    subtitleTrgPosition: String,
    subtitleEmbedStatus: String,
    subtitleEmbeddedAt: String,
  },
  data() {
    return {
      api_options: [
        { label: 'azure', value: 'AZURE' },
        { label: 'whisper', value: 'WHISPER' },
      ],
      video: undefined,
      videoMimeType: undefined,
      waveformPeaks: undefined,
      waveformDuration: undefined,
      selectedApi: 'WHISPER',
      uploadedFile: null,
      captionResult: undefined,
      isSeeked: true,
      isRegionSeeked: false,
      subtitles: undefined,
      videoHeight: undefined,
      videoWidth: undefined,
      zoomRate: 100,
      pixelsPerSecond: 0,
      waveSurferDuration: 0,
      scaleWidth: 0,
      videoIsPaused: true,
      videoDuration: undefined,
      videoLoaded: false,
      toShowVideoCurrentTime: 0,
      state: reactive({
        waveSurfer: null,
        waveSurferRegions: null,
      }),
      frameRate: '30Fr NDF',
      frameRateList: {
        '30Fr NDF': 30,
        '30Fr DF': 29.97,
        '25Fr': 25,
        '24Fr': 24, // 24P・23.98P // TODO: どっち?
        '24Fr on 30Fr': 30,
      },

      formAimodels: undefined,
      formGlossaries: undefined,

      isCreatedCaption: false, // videoのmetadataの取得が完了し、captionを整形したか否か
      isLoadedWaveSurfer: false, // 波形のロードw完了したか否か
      waveLoading: undefined, // 波形のロードの際に使用するローディング画面

      initialCaptions: undefined,

      form: {
        srcInputMethod: 'only__transcription',
        videoFile: undefined,
        transcriptFile: undefined,
        videoFileName: "選択されていません",
        transcriptFileName: "選択されていません",

        validation: this.validation,
        srcLanguageCode: "英",
        trgLanguageCode: "日",
        glossaryId: "",
        aimodelId: undefined,
        videoLanguage: 'en',
        captions: [],

      },

      subtitleSetting: {
        srcVisibility: this.subtitleSrcVisibility,
        trgPosition: this.subtitleTrgPosition,
      },

      modalTitleSetting: {
        srcVisibility: '',
        trgPosition: '',
      },

      // ダウンロードをする時に確認を飛ばすためのフラグ
      isGotoDownload: false,
    };
  },
  components: {
    UploadFilled,
    MoreFilled,
    Plus,
    Minus,
    VideoPlay,
    VideoPause,
    Setting,
    EditPen,
    Download,
    TranslationOptions,
    ContextMenu,
    menubar,
    Title,
    footerComponent,
    modal,
    DownloadModal,
  },
  methods: {
    async fetchWaveformPeaks(videoSource) {
      this.waveformPeaks = undefined;
      this.waveformDuration = videoSource.waveform_duration || undefined;

      if (!videoSource.waveform_peaks_url) {
        return;
      }

      try {
        const { data } = await axios.get(videoSource.waveform_peaks_url);
        this.waveformPeaks = data.peaks;
        this.waveformDuration = data.duration || this.waveformDuration;
      } catch (error) {
        console.warn('Waveform peaks could not be loaded.', error);
      }
    },
    inferVideoMimeType(url, mimeType) {
      if (mimeType && mimeType !== 'binary/octet-stream' && mimeType !== 'application/octet-stream') {
        return mimeType;
      }

      if (!url || typeof url !== 'string') {
        return undefined;
      }

      const path = new URL(url, window.location.href).pathname.toLowerCase();
      if (path.endsWith('.mp4') || path.endsWith('.m4v')) {
        return 'video/mp4';
      }
      if (path.endsWith('.mpeg') || path.endsWith('.mpg')) {
        return 'video/mpeg';
      }
      if (path.endsWith('.mp3')) {
        return 'audio/mpeg';
      }
      if (path.endsWith('.m4a')) {
        return 'audio/mp4';
      }
      if (path.endsWith('.wav')) {
        return 'audio/wav';
      }

      return undefined;
    },
    updateSubtitleInfo(closeModal) {
      this.subtitleSetting.srcVisibility = this.modalTitleSetting.srcVisibility;
      this.subtitleSetting.trgPosition = this.modalTitleSetting.trgPosition;

      const postData = new FormData();
      postData.append('subtitleSrcVisibility', this.subtitleSetting.srcVisibility);
      postData.append('subtitleTrgPosition', this.subtitleSetting.trgPosition);

      const response = axios.post(this.route('video_translate.update', this.videoTranslateId), postData)
        .then((res) => {
          if (res.status !== 200) {
            alert('設定の更新に失敗しました。\nもう一度お試しください');
          } else {
            alert('設定を更新しました。');
          }
          closeModal();
        })
        .catch(err => {
          const data = err.response.data;
          alert(Object.values(data.error)[0]);
        })
      this.addCaptionToVideo(this.captionResult);
      closeModal();
    },
    canselSubtitleInfo(closeModal) {
      this.modalTitleSetting.srcVisibility = this.subtitleSetting.srcVisibility;
      this.modalTitleSetting.trgPosition = this.subtitleSetting.trgPosition;
    },

    async uploadVideoFile() {
      // ローディング画面を表示
      const storeLoading = ElLoading.service(({
        text: '動画形式を確認中...このままお待ちください',
      }));

      // formのvalidation
      if (!this.form.videoFile) {
        alert('動画ファイルをアップロードしてください。');
        storeLoading.close();
        return;
      }

      if (!this.form.videoLanguage) {
        alert('動画の言語を選択してください');
        storeLoading.close();
        return;
      }
      // TODO: 動画ファイルの形式の確認をする

      // 書き起こしファイルの形式を確認する

      // 元言語を動画の言語とする
      this.form.srcLanguageCode = this.parsedSrcCodeFromVideoLanguage;
      if (!this.useTranslateFeature) {
        this.form.trgLanguageCode = undefined;
        this.form.aimodelId = undefined;
      }


      const element = this.form.videoFile;

      // 動画/音声ファイルの種類を判定
      const isAudioFile = ['mp3', 'm4a', 'wav'].includes(this.form.videoFile.name.split('.').pop().toLowerCase());

      // ファイルの拡張子を取得
      const fileExtension = this.form.videoFile.name.split('.').pop().toLowerCase();

      // 許可されている拡張子のリスト
      const allowedExtensions = ['mp4', 'm4v', 'mpeg', 'mpg', 'mp3', 'm4a', 'wav'];

      // ファイル拡張子が許可されているかチェック
      if (!allowedExtensions.includes(fileExtension)) {
        alert('現在アップロードされたファイル形式には対応していません。mp4, m4v, mpeg, mpg, mp3, m4a, wav の形式でアップロードしてください。');
        storeLoading.close();
        return;
      }

      // ファイルサイズのバリデーション
      const maxUploadfileSizeByte = this.form.validation.maxUploadSize.filesizeByte;
      if(element.size > maxUploadfileSizeByte){
        alert(maxUploadfileSizeByte / (1024 ** 3) + 'GBを超えるファイルはアップロードできません。');
        storeLoading.close();
        return;
      }

      // 動画の長さとコーデックのバリデーションをかける
      try{
        let durationSecond = null;
        let codec = null;
        const maxDurationSecond = this.form.validation.maxUploadSize.durationSecond;
        const ffmpeg = new FFmpeg();
        await ffmpeg.load({ log: true });
        await ffmpeg.writeFile(this.form.videoFileName, await fetchFile(this.form.videoFile));
        ffmpeg.on("log", ({ type, message }) => {
          // Duration情報を取得する
          const match = message.match(/Duration:\s(\d+):(\d+):(\d+\.\d+)/);
          if (match) {
              const hours = parseInt(match[1], 10);
              const minutes = parseInt(match[2], 10);
              const seconds = parseFloat(match[3]);
              durationSecond = hours * 3600 + minutes * 60 + seconds;
          }

          // 添付画像ストリームは除外する
          if (!isAudioFile && message.includes('attached pic')) {
            return;
          }

          // 音声ファイルの場合はAudioコーデック情報を取得
          const audioCodecMatch = isAudioFile && message.match(/Audio:\s([^\s,]+)/);
          if (audioCodecMatch) {
            codec = audioCodecMatch[1];
            return;
          }

          // 動画ファイルの場合はVideoコーデック情報を取得
          const videoCodecMatch = !isAudioFile && message.match(/Video:\s([^\s,]+)/);
          if (videoCodecMatch) {
            codec = videoCodecMatch[1];
          }
        });
        await ffmpeg.exec([
          '-i', this.form.videoFileName
        ]);
        if(durationSecond === null){
          // catchの処理に飛ばす
          throw new Error();
        }

        // 動画の長さのバリデーション
        if (durationSecond > maxDurationSecond) {
          alert('ファイルの長さが' + maxDurationSecond / 3600 +'時間を超えています。');
          storeLoading.close();
          return;
        }

        // 音声ファイルでない場合のみコーデックチェックを行う
        if (!isAudioFile) {
          // コーデックがnullの場合はエラー
          if (codec === null) {
            throw new Error();
          }

          // 許可されるコーデックのリスト
          const allowedCodecs = ["h264", "mpeg1video", "mpeg2video"];

          // コーデックが許可されていない場合
          if (!allowedCodecs.includes(codec)) {
            alert('不正なファイル形式です。');
            storeLoading.close();
            return;
          }
        }
      }catch(e){
        alert('ファイルの読み込みに失敗しました。もう一度お試しください。');
        storeLoading.close();
        return;
      }

      // 言語ペアが設定されているか
      if (!this.form.srcLanguageCode) {
        alert('翻訳不可な動画の言語が選択されています。');
        storeLoading.close();
        return;
      }
      if (!this.form.trgLanguageCode && this.useTranslateFeature) {
        alert('目的言語を選択してください。');
        storeLoading.close();
        return;
      }

      // 言語ペアが同じでないか
      if (this.form.srcLanguageCode === this.form.trgLanguageCode) {
        alert('同じ言語を選択することはできません。');
        storeLoading.close();
        return;
      }

      if (!this.form.srcInputMethod) {
        alert('字幕の作成方法を選択してください。');
        storeLoading.close();
        return;
      }
      if (this.form.srcInputMethod === 'import' && !this.form.transcriptFile) {
        alert('書き起こしファイルをアップロードしてください。');
        storeLoading.close();
        return;
      }

      if (this.form.aimodelId === undefined && this.useTranslateFeature) {
        alert('AIモデルを選択してください。');
        storeLoading.close();
        return;
      }


      // form送信
      const postData = new FormData();
      for (const [key, value] of Object.entries(this.form)) {
        postData.append(key, value ?? '');
      }
      postData.append('isOnlyTranscription', !this.useTranslateFeature);

      if (this.parsedSrcCodeFromVideoLanguage === undefined) {
        if (!confirm('字幕翻訳できない動画の言語が選択されていますが良いでしょうか？')) {
          storeLoading.close();
          return;
        }
      }

      // ローディング画面のテキストを変更
      storeLoading.setText('動画をアップロード中...このままお待ちください');

      const response = axios.post('/translate/video', postData,
        {
          onUploadProgress: (progressEvent) => {
            storeLoading.setText(Math.floor(progressEvent.loaded * 100 / progressEvent.total) + "%アップロード完了");
            if (progressEvent.loaded === progressEvent.total) {
              storeLoading.setText('動画を保存中...このままお待ちください');
            }
          },
        })
        .then((res) => {
          if (res.status !== 200) {
            alert('動画のインポート・翻訳に失敗しました。\nもう一度お試しください');
          } else {
            alert('動画のインポートに成功しました。\n一覧ページに移動します。');
          }
          window.location = this.route('video_translate.index');
          storeLoading.close();

        })
        .catch(err => {
          storeLoading.close();
          const data = err.response.data;
          if (data === undefined || data.error == undefined) {
            alert('予期せぬエラーが発生しました。再度お試しください。');
          } else {
            alert(Object.values(data.error)[0]);
          }
        })
    },

    async updateVideoInfo() {
      // 言語ペアが設定されているか
      if (!this.form.trgLanguageCode) {
        alert('目的言語を選択してください。');
        return;
      }

      // 言語ペアが同じでないか
      if (this.form.srcLanguageCode === this.form.trgLanguageCode) {
        alert('同じ言語を選択することはできません。');
        return;
      }

      if (this.form.aimodelId === undefined) {
        alert('AIモデルを選択してください。');
        return;
      }

      const updateVideoInfoLoading = ElLoading.service(({
        text: '用語集・AIモデルを更新中...',
      }));

      // form送信
      let postData = new FormData();
      for (const [key, value] of Object.entries(this.form)) {
        postData.append(key, value ?? '');
      }
      // captionは保存しないので削除する
      postData.delete('captions');
      postData.delete('videoLanguage');

      const response = axios.post('/translate/video/' + this.videoTranslateId, postData)
        .then((res) => {
          if (res.status !== 200) {
            alert('設定の更新に失敗しました。\nもう一度お試しください');
          } else {
            alert('設定を更新しました。');
          }
          updateVideoInfoLoading.close();
        })
        .catch(err => {
          updateVideoInfoLoading.close();
          const data = err.response.data;
          alert(Object.values(data.error)[0]);
        })
    },

    /**
     * captionをtsvでDLする関数
     */
    saveCaptions() {

      const updateLoading = ElLoading.service(({
        text: '字幕を保存中...',
      }));
      const response = axios.post(this.route('video_translate.updateCaption', this.videoTranslateId),
        { 'captions': this.captionResult })
        .then((res) => {
          updateLoading.close();
          if (res.status !== 200) {
            alert('字幕の更新に失敗しました。\nもう一度お試しください');
          } else {
            alert('字幕を更新しました。');
            this.initialCaptions = this.captionResult;
          }

        })
        .catch(err => {
          updateLoading.close();
          const data = err.response.data;
          alert(Object.values(data.error)[0]);
        })

    },
    /**
     * captionをwaveSurferに反映する関数
     *
     * @param array captions waveSurferに反映するcaptionの配列
     */
    addCaptionToWave(captions) {
      this.waveSurferRegions?.clearRegions();
      let updateCaptions = captions;
      for (let i = 0; i < updateCaptions.length; ++i) {
        let caption = captions[i];
        const addedRegion = this.waveSurferRegions.addRegion({
          start: caption['start'],
          end: caption['end'],
          drag: false,
          resize: !this.prohibitEdit,
          // content: (i + 1).toString(),
        });
        updateCaptions[i].id = addedRegion.id;
      }
      // console.log('addcaptoiontowave');
      this.captionResult = updateCaptions;
    },
    /**
     * captionをVideoに反映する関数
     *
     * @param {array} captions waveSurferに反映するcaptionの配列
     */
    addCaptionToVideo(captions) {
      const video = this.$refs.video;
      let track_src = undefined;
      let track_trg = undefined;
      if (video.textTracks.length === 0) {
        track_trg = video.addTextTrack('captions', '字幕', 'jp');
        track_src = video.addTextTrack('captions', '原文', 'jp');
      } else {
        track_src = video.textTracks[0];
        track_trg = video.textTracks[1];
        while (track_src.cues.length > 0) {
          track_src.removeCue(track_src.cues[0]);
        }
        while (track_trg.cues.length > 0) {
          track_trg.removeCue(track_trg.cues[0]);
        }
      }
      track_src.mode = 'showing';
      track_trg.mode = 'showing';

      for (const caption of captions) {
        let trg_cue = new VTTCue(caption['start'], caption['end'], caption['trg']);
        let src_cue = new VTTCue(caption['start'], caption['end'], caption['src']);
        if (this.subtitleSetting.trgPosition === '上部') {
          trg_cue.line = 1;
          src_cue.line = 10;
        } else {
          trg_cue.line = 10;
          src_cue.line = 1;
        }

        track_trg.addCue(trg_cue);
        if (this.subtitleSetting.srcVisibility === '表示') {
          track_src.addCue(src_cue);
        }
      }
    },
    async updateTranslationResources() {
      if (!this.useTranslateFeature && this.isShowCreate) {
        return;
      }
      if (this.isShowCreate) {
        this.form.srcLanguageCode = this.parsedSrcCodeFromVideoLanguage;
      }
      try {
        const res = await axios.post('/fetch_translation_resources_by_lang', {
          src_language_code: this.form.srcLanguageCode,
          trg_language_code: this.form.trgLanguageCode,
        });
        this.formAimodels = res.data.aimodels;
        this.formGlossaries = res.data.glossaries;
        if (res.data.aimodels?.length == 0) {
          ElMessage.error({ grouping: true, message: '使用できるAIモデルがありません。' });
          return;
        }
        this.form.aimodelId = this.formAimodels[0].id;
      } catch (error) {
        console.error(error);
      }
    },
    changeWaveCurrentTime(index) {
      if (this.captionResult[index] === undefined) {
        alert('不正な操作です');
      }
      const updatedTime = this.captionResult[index].start;
      this.waveSurfer.setTime(updatedTime);
    },
    syncCaptionWithFramerate() {
      const updatedCaptionResult = this.captionResult.map((c) => {

        // console.log(c);
        const region = this.getRegionById(c.id);
        const fixedStart = this.fixedTime(c.start);
        const fixedEnd = this.fixedTime(c.end);
        if (fixedStart !== region.start || fixedEnd !== region.end) {
          region.setOptions({ start: fixedStart, end: fixedEnd });
        }
        c.start = fixedStart;
        c.end = fixedEnd;
        c.startTimes = this.getTimeRecord(c.start);
        c.endTimes = this.getTimeRecord(c.end);
        return c;
      });
      // console.log(updatedCaptionResult);
      this.captionResult = updatedCaptionResult;
      // console.log('regin synced');
    },
    /**
     * 3点リーダーをクリックした際に、ポップアップを表示する関数
     *
     * @param {Number} regionId ポップアップを表示するregionのid
     * @param {event} e ポップアップをクリックしたイベント
     */
    showContextMenu(regionId, e) {
      if (this.$refs.contextMenu.isHide()) {
        this.$refs.contextMenu.show(regionId, 0.01, this.capSplitRegion(regionId), e, this.glossaryId, this.aimodelId);
      }
    },

    zoomWaveSurfer(diff) {
      if (!this.waveSurfer || !this.isLoadedWaveSurfer || !this.waveSurferDuration) {
        return;
      }

      this.zoomRate += diff;
      this.zoomRate = Math.max(100, this.zoomRate);
      this.zoomRate = Math.min(this.zoomRate, 1000);


      this.waveSurfer?.zoom(this.zoomRate);

      if (this.zoomRate === 100) {
        const waveSurferDivWidth = 0.9 * (document.body.clientWidth - 24); // div要素の幅
        const waveSurferWidth = Math.ceil(this.waveSurferDuration * (this.zoomRate || 0)); // 波形の長さ

        // 動画の時間が長いと拡大しなくてもシークバーが出てしまう
        // 動画の時間がないと拡大しない場合に見切れるのでその対策として、max関数を使用
        this.scaleWidth = Math.max(waveSurferDivWidth, waveSurferWidth);
        this.pixelsPerSecond = this.scaleWidth / this.waveSurferDuration;
      } else {
        this.scaleWidth = Math.ceil(this.waveSurferDuration * (this.zoomRate || 0));
        this.pixelsPerSecond = this.scaleWidth / this.waveSurferDuration;
      }
    },
    /**
     *
     * ポップアップのコンポーネントによるcaptionの更新を反映する関数
     *
     * @param {array} updateCaption 更新後のcaptionの配列
     */
    handleCaptionUpdate(updateCaption) {
      const fixIndexCaption = updateCaption.map(function (object, index) {
        if ((index + 1) !== parseInt(object.no, 10)) {
          object.no = (index + 1).toString();
        }
        return object;
      });
      this.captionResult = fixIndexCaption;
    },
    /**
     * timeを時、分、秒、フレーム数のオブジェクトに変換する関数
     *
     * @param {Number} time wavesurferの表示に関する時間
     */
    getTimeRecord(time) {
      let res = new Object();
      let time_remaining = time;

      res.hour = parseInt(time_remaining / 3600);
      time_remaining = new Decimal(time_remaining).minus(res.hour * 3600).toNumber();

      res.minute = parseInt(time_remaining / 60);
      time_remaining = new Decimal(time_remaining).minus(res.minute * 60).toNumber();

      res.second = parseInt(time_remaining);
      time_remaining = new Decimal(time_remaining).minus(res.second).toNumber();

      res.millisecond = this.getMilliSecond(time_remaining);
      return res;
    },
    /**
     * 時、分、秒、フレームのオブジェクトをtimeに変換する関数
     *
     * @param {Object} times 時、分、秒、フレームのオブジェクト
     */
    getRegionTime(times) {
      return times.hour * 3600 + times.minute * 60 + times.second + times.millisecond / 1000;
    },
    /**
     * フレーム数を返す関数
     *
     * @param {Number} time wavesurferの表示に関する時間
     */
    getMilliSecond(time) {
      const fractionalPart = Decimal(time).toDP(3, Decimal.ROUND_DOWN).mod(1).times(1000).toNumber();
      return fractionalPart;
    },
    fixedTime(time) {
      return Math.floor(time) + new Decimal(this.getMilliSecond(time)).times(0.001).toNumber();
    },
    isChangedTime(oldRecord, newRecord) {
      // console.log(oldRecord);
      // console.log(newRecord);
      return oldRecord?.hour !== newRecord?.hour
        || oldRecord?.minute !== newRecord?.minute
        || oldRecord?.second !== newRecord?.second
        || oldRecord?.millisecond !== newRecord?.millisecond;
    },
    CarriedChangedTimes(times) {
      if (times.millisecond < 0) {
        times.second -= 1;
        times.millisecond = 1000 + times.millisecond;
      }

      if (times.second === -1) {
        times.minute -= 1;
        times.second = 59;
      }

      if (times.minute === -1) {
        times.hour -= 1;
        times.minute = 59;
      }

      if (times.millisecond >= 1000) {
        times.second += Math.floor(times.millisecond / 1000);
        times.millisecond %= 1000;
      }

      if (times.second >= 60) {
        times.minute += Math.floor(times.second / 60);
        times.second %= 60;
      }
      if (times.minute >= 60) {
        times.hour += Math.floor(times.minute / 60);
        times.minute %= 60;
      }

      return times;
    },
    hasInvalidTimes(times) {
      if (times.minute > 60 || times.minute < 0) {
        return true;
      }
      if (times.second > 60 || times.second < 0) {
        return true;
      }
      if (times.millisecond > 1000 || times.millisecond < 0) {
        return true;
      }
      return false;
    },
    capSplitRegion(regionId) {
      const c = this.getCaptionById(regionId);
      const end = c.endTimes;
      // 100msの波形のみ分割できるようにする(バグった場合は数字を変える)
      for (let index = 1; index <= 100; index++) {
        const editedStart = this.copy(c.startTimes);
        editedStart.millisecond += index;
        // console.log(editedStart);
        // console.log(end);
        if (!this.isChangedTime(this.CarriedChangedTimes(editedStart), end)) {
          return false;
        }
      }
      return true;
    },
    coloringBackGround(event) {

      let element = event.target;
      while (!element.classList.contains('div__caption')) {
        element = element.parentNode;
      }

      this.resetCaptionBackground();

      const changeBGFirstElement = element.childNodes[0]?.childNodes[1]?.childNodes[0];
      const changeBGSecondElement = element.childNodes[1]?.childNodes[1]?.childNodes[0];

      if (changeBGFirstElement !== undefined) {
        changeBGFirstElement.classList.add('selected__div');
      }

      if (changeBGSecondElement !== undefined) {
        changeBGSecondElement.classList.add('selected__div');
      }
    },
    resetCaptionBackground() {
      const allElements = document.getElementsByClassName('textarea__caption');
      for (const e of allElements) {
        e.classList?.remove('selected__div');
      }
    },
    getRegionById(regionId) {
      const regions = this.waveSurferRegions.getRegions();
      for (const r of regions) {
        if (r.id === regionId) {
          return r;
        }
      }
      return undefined;
    },
    getCaptionById(id) {
      const captions = this.captionResult;
      for (const c of captions) {
        if (c.id === id) {
          return c;
        }
      }
      return undefined;
    },
    copy(obj) {
      return JSON.parse(JSON.stringify(obj));
    },
    captionLength(caption) {
      return Math.abs(caption.start - caption.end) * this.pixelsPerSecond;
    },
    alreadyLength(caption) {
      let length = 0;
      for (const c of this.captionResult) {
        if (c.id === caption.id) {
          break;
        }
        length = c.end * this.pixelsPerSecond;
      }
      return length;
    },
    captionLeftMargin(caption) {
      return caption.start * this.pixelsPerSecond - this.alreadyLength(caption);
    },

    toggleVideoPlayback() {
      if (this.video.paused) {
        this.video.play();
      } else {
        this.video.pause();
      }
    },
    changeVideoTime(interval) {
      const nowTime = this.video?.currentTime;
      this.video.currentTime = Decimal.add(nowTime, interval);
    },
    changeVideoFile(e) {
      this.form.videoFile = e?.target?.files[0];
      this.form.videoFileName = this.form.videoFile.name;
    },

    changeTranscriptFile(e) {
      this.form.transcriptFile = e?.target?.files[0];
      this.form.transcriptFileName = this.form.transcriptFile.name;
    },
    leaveEditPage: function (event) {
      // ダウンロードの時はアラートを出さない
      if (this.isGotoDownload) {
        this.isGotoDownload = false;
      } else {
        // 他のページに移動する時はアラートを出す
        event.preventDefault();
        event.returnValue = '';
      }
    },
    closePage: function () {
      this.discardEdit();
      window.close();
    },
    discardEdit: function () {
      axios.post(this.route('video_translate.updateCaption', this.videoTranslateId),
        { 'captions': this.initialCaptions })
        .then((res) => {
          updateLoading.close();
          if (res.status !== 200) {
            alert('字幕の更新に失敗しました。\nもう一度お試しください');
          } else {
            alert('字幕を更新しました。\n一覧ページに移動します。');
          }


        })
        .catch(err => {
          const data = err.response.data;
          alert(Object.values(data.error)[0]);
        })
    },
    openDownloadModal(id, subtitleEmbedStatus, subtitleEmbeddedAt) {
      this.$refs.downloadModal.openDownloadModal(id, subtitleEmbedStatus, subtitleEmbeddedAt);
    },

    scrollToCaption(index) {
      const element = document.getElementsByClassName('div__caption')[index];
      const secondary = document.getElementById('secondary');
      if (element && secondary) {
        const elementHeight = element.offsetHeight;
        const secondaryHeight = secondary.clientHeight;
        const scrollPosition = element.offsetTop - secondary.offsetTop - (secondaryHeight / 2) + (elementHeight / 2);

        secondary.scrollTo({
          top: scrollPosition,
          behavior: 'smooth'
        });
      }
    }
  },
  watch: {
    computedCaption: {
      handler: function (newCaption, oldCaption) {
        if (oldCaption === undefined || oldCaption.length === 0) {
          return;
        }

        // TODO: ハコを分割 or 統合した場合にwavesurferに反映する
        if (oldCaption.length < newCaption.length) {
          for (let i = 0; i < newCaption.length; ++i) {
            const region = this.getRegionById(newCaption[i].id);
            const caption = newCaption[i];
            newCaption[i].start = this.fixedTime(caption['start']);
            newCaption[i].end = this.fixedTime(caption['end']);
            newCaption[i].startTimes = this.getTimeRecord(caption['start']);
            newCaption[i].endTimes = this.getTimeRecord(caption['end']);
            if (region === undefined) {
              // NOTE: to add
              const addedRegion = this.waveSurferRegions.addRegion({
                start: caption['start'],
                end: caption['end'],
                drag: false,
                resize: !this.prohibitEdit,
                // content: (i + 1).toString(),
              });
              newCaption[i].id = addedRegion.id;
            } else {
              // NOTE: to update
              const toUpdateParams = {
                start: caption.start,
                end: caption.end,
                // content: (i + 1).toString(),
              };
              region.setOptions(toUpdateParams);
            }
          }
          this.addCaptionToVideo(newCaption);
          this.captionResult = newCaption;
          return;
        }

        if (oldCaption.length > newCaption.length) {
          const newRegionIds = newCaption.map((c) => c.id);

          for (const caption of oldCaption) {
            const captionIndex = newCaption.findIndex((c) => c.id === caption.id);
            const region = this.getRegionById(caption.id);
            if (region === undefined) {
              continue;
            }
            if (!newRegionIds.includes(caption.id)) {
              // NOTE: to delete
              region.remove();
            } else {
              // NOTE: to update
              newCaption[captionIndex].startTimes = this.getTimeRecord(newCaption[captionIndex]['start']);
              newCaption[captionIndex].endTimes = this.getTimeRecord(newCaption[captionIndex]['end']);
              const toUpdateParams = {
                start: newCaption[captionIndex].start,
                end: newCaption[captionIndex].end,
                // content: (captionIndex + 1).toString(),
              };
              region.setOptions(toUpdateParams);

            }
          }

          this.addCaptionToVideo(newCaption);
          this.captionResult = newCaption;
          return;
        }

        // NOTE: 特殊な変換を検知する
        const carriedCaptions = newCaption.map((c) => {
          c.startTimes = this.CarriedChangedTimes(c.startTimes);
          c.endTimes = this.CarriedChangedTimes(c.endTimes);
          c.start = this.getRegionTime(c.startTimes);
          c.end = this.getRegionTime(c.endTimes);
          return c;
        });

        // console.log('carriedCaptions');
        // console.log(carriedCaptions);
        // console.log('carriedCaptions');

        // NOTE: 字幕の重複を検知する
        for (const caption of carriedCaptions) {
          for (const compareCaption of carriedCaptions) {
            if (caption.id === compareCaption.id) {
              if (caption.start === caption.end) {
                ElMessage.error({ grouping: true, message: '字幕を重複させることはできません。' });
                this.captionResult = oldCaption;
                return;
              }
            }
            else if (caption.start <= compareCaption.start && compareCaption.start <= caption.end) {
              ElMessage.error({ grouping: true, message: '字幕を重複させることはできません。' });
              this.captionResult = oldCaption;
              return;
            }

          }
        }

        let changedCaption = carriedCaptions.filter(
          (c, index) => this.isChangedTime(c.startTimes, oldCaption[index].startTimes) ||
            this.isChangedTime(c.endTimes, oldCaption[index].endTimes) ||
            c.src !== oldCaption[index].src ||
            c.trg !== oldCaption[index].trg
        );

        // NOTE: 箱の位置が変わっていない場合、処理を終了
        if (changedCaption.length === 0) {
          // console.log('not change caption');
          return;
        }

        for (const caption of changedCaption) {
          const region = this.getRegionById(caption.id);
          if (region === undefined) {
            ElMessage.error('波形が見つかりませんでした');
            this.captionResult = oldCaption;
            return;
          }

          const updateData = { start: caption.start, end: caption.end };

          if (updateData.start >= this.waveSurferDuration || updateData.end >= this.waveSurferDuration) {
            ElMessage.error({ grouping: true, message: '動画の時刻を超えて字幕を設定することはできません。' });
            this.captionResult = oldCaption;
            return;
          }
          if (updateData.start < 0 || updateData.end < 0) {
            ElMessage.error({ grouping: true, message: '時刻をマイナスにすることはできません。' });
            this.captionResult = oldCaption;
            return;
          }

          if (this.hasInvalidTimes(caption.startTimes) || this.hasInvalidTimes(caption.endTimes)) {
            ElMessage.error({ grouping: true, message: '不正な時刻が入力されています。' });
            this.captionResult = oldCaption;
            return;
          }
          if (updateData.start > updateData.end && updateData.end !== 0) {
            ElMessage.error({ grouping: true, message: '開始時刻を終了時刻より前にすることはできません。' });
            this.captionResult = oldCaption;
            return;
          }
          region.setOptions(updateData);
        }
        carriedCaptions.sort((a, b) => a.start - b.start);
        this.addCaptionToVideo(carriedCaptions);
        this.captionResult = carriedCaptions;
      },
      deep: true,
    },
    'form.srcInputMethod': {
      handler: function (newForm, oldForm) {
        if (oldForm === undefined) {
          return;
        }

        if (newForm !== 'only__transcription') {
          ElMessage.info('中国語、韓国語は選択できません。');
          // 中国語と韓国語は翻訳機能を持っていない(音声認識のみ)

          // 現在選択している「動画の言語」が中国語または韓国語のとき、英語に変更する。
          if (this.form.videoLanguage === 'zh' || this.form.videoLanguage === 'ko') {
            this.form.videoLanguage = 'en';
          }

          // 「動画の言語」に中国語または韓国語を選択できないようにする
          for (let lang of this.$refs.srcLanguage) {
            if (lang.value === 'zh' || lang.value === 'ko') {
              lang.disabled = true;
            }
          }

          // 「翻訳先言語」に中国語または韓国語を選択できないようにする
          for (let lang of this.$refs.trgLanguage) {
            if (lang.value === '中' || lang.value === '韓') {
              lang.disabled = true;
            }
          }
          this.updateTranslationResources();

        } else {
          for (let lang of this.$refs.srcLanguage) {
            lang.disabled = false;
          }
          for (let lang of this.$refs.trgLanguage) {
            lang.disabled = false;
          }

        }
      },
      deep: true,

    }
  },
  computed: {
    canTranslate() {
      return this.uploadedFile != undefined;
    },
    computedCaption() {
      return JSON.parse(JSON.stringify(this.captionResult ?? ''));
    },
    timeCode() {
      const time = this.toShowVideoCurrentTime;
      const times = [time / 3600, time / 60, time % 60].map((t) => Math.floor(t).toString().padStart(2, "0"));
      times.push(new Decimal(time).minus(new Decimal(time).floor()).times(1000).round().toString().padStart(3, "0"));
      return times.join(":");
    },
    // isShowCreate : True→新規作成画面、False→編集画面
    isShowCreate() {
      return !this.videoSourceUrl;
    },
    useTranslateFeature() {
      if (!this.translateTypeList) {
        return;
      }
      const srcInputMethodCandidates = this.translateTypeList.map((t) => t.value);
      if (this.form.srcInputMethod !== undefined && !srcInputMethodCandidates.includes(this.form.srcInputMethod)) {
        alert('不正な値が設定されています。');
      }
      return this.form.srcInputMethod === 'import' || this.form.srcInputMethod === 'transcription';
    },
    parsedSrcCodeFromVideoLanguage() {
      const videoLanguageName = this.videoLanguages.find((l) => l.value === this.form.videoLanguage).name;
      const srcLanguage = this.translationLanguages.find((l) => l.name === videoLanguageName);
      return srcLanguage.code;
    },
    prohibitEdit() {
      return !this.isEditingByMe && !this.isShowCreate;
    },
    hiddenSettingIcon() {
      return this.srcLanguageCode === '中' || this.srcLanguageCode === '韓' ;
    },
  },
  mounted: async function () {

    if (!this.videoSourceUrl) {
      this.$refs.videoSettingModal.openModal({ is_wide: true });
      // this.$refs.subtitleSettingModal.openModal({ is_wide: true });
      return;
    }

    if (!this.isEditingByMe) {
      const confirmOverride = confirm(
        this.editingUser+'が編集中です。ロックを解除しますか？'
      );
      if (confirmOverride) {
        try {
          Inertia.put(`/translate/video/${this.videoTranslateId}/override`);
        } catch (error) {
          alert('エラーが発生しました。再試行してください。');
        }
      }
    }

    const videoLoading = ElLoading.service({ fullscreen: true, showClose: true, text: '動画を読込中...' });

    try {
      const { data: videoSource } = await axios.get(this.videoSourceUrl);
      this.videoSource = videoSource.url;
      this.videoMimeType = this.inferVideoMimeType(videoSource.url, videoSource.mime_type);
      await this.fetchWaveformPeaks(videoSource);
      await this.$nextTick();
    } catch (error) {
      videoLoading.close();
      alert('動画の読み込みに失敗しました。');
      return;
    }

    // 動画の初期設定
    const video = this.$refs.video;
    this.video = video;
    video.load();

    video.addEventListener('loadeddata', () => {
      this.videoLoaded = true;
      videoLoading.close();
      this.videoDuration = this.video.duration;

      let updatedCaptions = this.captions.map((c) => {
        c.start = this.fixedTime(c.start);
        c.end = this.fixedTime(c.end);
        c.startTimes = this.getTimeRecord(c.start);
        c.endTimes = this.getTimeRecord(c.end);
        c.caption = c['src'];
        c.trg = c['trg'];
        return c;
      });
      updatedCaptions = updatedCaptions.filter((c) => c.start <= this.videoDuration && c.end <= this.videoDuration);
      // 字幕のstartとendが被っている箇所を修正する
      for (let i = 0; i < updatedCaptions.length - 1; ++i) {
        if (updatedCaptions[i].end === updatedCaptions[i + 1].start) {
          updatedCaptions[i].end -= 0.005;
          updatedCaptions[i].endTimes = this.getTimeRecord(updatedCaptions[i].end);
        }
      }
      // 字幕の開始と終了が一緒の字幕を削除する
      updatedCaptions = updatedCaptions.filter((c) => c.start >= 0 && c.end >= 0 && c.start < c.end);


      if (updatedCaptions.length === 0) {
        updatedCaptions.push({
          'no': 0,
          'start': 0,
          'end': this.videoDuration / 2,
          'startTimes': this.getTimeRecord(0),
          'endTimes': this.getTimeRecord(this.videoDuration),
          'src': 'source sample',
          'trg': 'target sample',
        });
      }
      this.captionResult = updatedCaptions;
      this.initialCaptions = updatedCaptions;

      this.addCaptionToVideo(this.captionResult);

      if (this.isLoadedWaveSurfer) {
        this.addCaptionToWave(this.captionResult);
      }

      this.$nextTick(function () {
        // NOTE: scroll barのサイズを含んだ計算を行うので、nextTick内に記述
        this.zoomWaveSurfer(-999);
      });
    });

    video.onseeking = () => {
      if (!this.isSeeked) {
        this.isSeeked = true;
        this.waveSurfer.setTime(video.currentTime);
        this.waveSurfer.pause();
      } else {
        this.isSeeked = false;
      }
      video.pause();
    };

    video.onseeked = () => {
      video.pause();
    };

    video.onplay = () => {
      this.waveSurfer.play();
      this.videoIsPaused = false;
    };

    video.onpause = (e) => {
      this.waveSurfer.pause();
      this.waveSurfer.setTime(e?.currentTarget?.currentTime);
      this.videoIsPaused = true;
    };

    video.ontimeupdate = () => {
      this.toShowVideoCurrentTime = this.video.currentTime;
      let video = this.$refs.video;
      if (video.textTracks[0] === undefined) {
        return;
      }
      if (video.textTracks[1] === undefined) {
        return;
      }
      video.textTracks[0].mode = 'showing';
      video.textTracks[1].mode = 'showing';
    }

    // wavesurferの初期設定
    this.waveSurfer = WaveSurfer.create({
      container: '#waveform',
      waveColor: 'rgba( 111, 66, 201, 1 )',
      progressColor: 'purple',
      responsive: true,
    });

    this.waveSurferRegions = this.waveSurfer.registerPlugin(RegionsPlugin.create());

    this.waveSurfer.on('ready', (duration) => {
      this.waveSurferDuration = duration;
      this.isLoadedWaveSurfer = true;
      if (this.captionResult) {
        this.addCaptionToWave(this.captionResult);
      }
      this.zoomWaveSurfer(-999);
    });

    const loadWaveSurfer = (duration) => {
      this.isLoadedWaveSurfer = false;

      if (this.waveformPeaks && Number.isFinite(duration) && duration > 0) {
        // Passing peaks prevents WaveSurfer from fetching and decoding the full video in the browser.
        this.waveSurfer.load(this.videoSource, this.waveformPeaks, duration);
        return;
      }

      // Backward compatibility for existing records without precomputed peaks.
      this.waveSurfer.load(this.videoSource);
    };

    if (this.waveformDuration) {
      loadWaveSurfer(this.waveformDuration);
    } else if (Number.isFinite(this.video.duration) && this.video.duration > 0) {
      loadWaveSurfer(this.video.duration);
    } else {
      this.video.addEventListener('loadedmetadata', () => {
        loadWaveSurfer(this.video.duration);
      }, { once: true });
    }
    this.waveSurfer.setVolume(0);

    this.waveSurfer.on('seeking', (seek) => {
      if (this.video === undefined) {
        return;
      }
      if (!this.isSeeked) {
        this.video.currentTime = seek;
        this.isSeeked = true;
      } else {
        this.isSeeked = false;
      }
    });

    this.waveSurfer.on('scroll', (visibleStartTime, visibleEndTime) => {
      const numberElement = document.getElementById("Numbering--id");
      numberElement.scrollLeft = visibleStartTime * this.pixelsPerSecond;
    });

    this.waveSurferRegions.on('region-updated', (region, e) => {
      const updateCaption = this.captionResult.map((c) => {
        if (c.id !== region.id) {
          return c;
        }
        const fixedStart = this.fixedTime(region.start);
        const fixedEnd = this.fixedTime(region.end);
        if (fixedStart !== region.start || fixedEnd !== region.end) {
          region.setOptions({ start: fixedStart, end: fixedEnd });
        }
        c.start = fixedStart;
        c.end = fixedEnd;
        c.startTimes = this.getTimeRecord(c.start);
        c.endTimes = this.getTimeRecord(c.end);
        return c;
      });
      this.captionResult = updateCaption;
    });

    this.waveSurferRegions.on('region-in', (region) => {
      region?.setOptions({ color: 'rgba(126, 126, 126, 0.5)' });

      const toColoringIndex = this.captionResult.findIndex((l) => l.id === region.id);
      const lines = document.getElementsByClassName('div__caption');
      const changeBGFirstElement = lines[toColoringIndex]?.childNodes[0]?.childNodes[1]?.childNodes[0];
      const changeBGSecondElement = lines[toColoringIndex]?.childNodes[1]?.childNodes[1]?.childNodes[0];

      changeBGFirstElement?.classList.add('selected__div');
      // changeBGFirstElement?.focus(); // 移動する
      // changeBGFirstElement?.blur(); // 入力状態を解除する

      changeBGSecondElement?.classList.add('selected__div');

      this.scrollToCaption(toColoringIndex); // 自動スクロール

    });
    this.waveSurferRegions.on('region-out', (region) => {
      region?.setOptions({ color: 'rgba(0, 0, 0, 0.1)' });

      const toColoringIndex = this.captionResult.findIndex((l) => l.id === region.id);
      const lines = document.getElementsByClassName('div__caption');
      const changeBGFirstElement = lines[toColoringIndex]?.childNodes[0]?.childNodes[1]?.childNodes[0];
      const changeBGSecondElement = lines[toColoringIndex]?.childNodes[1]?.childNodes[1]?.childNodes[0];

      changeBGFirstElement?.classList.remove('selected__div');
      // changeBGFirstElement?.focus(); // 移動する
      // changeBGFirstElement?.blur(); // 入力状態を解除する

      changeBGSecondElement?.classList.remove('selected__div');
    });



    // NOTE: キーボードショートカットの設定
    onkeydown = (e) => {
      const clicekdTag = e.target?.tagName;
      if (e.code !== 'Space' || ['VIDEO', 'TEXTAREA'].includes(clicekdTag)) {
        return;
      }
      this.toggleVideoPlayback();
    };

    // $('#primary').resizable({
    //   aspectRatio: true,
    //   // handles: 'es,e',
    //   resize: (event, ui) => {
    //     // console.log('resized!!');
    //     // this.videoHeight = ui.size.height;
    //     // this.videoWidth = ui.size.width;
    //   },
    // });

    // // ウィンドウがリサイズされたときにmaxHeightを再計算
    $(window).resize(() => {
      //   const maxVideoWidth = 0.48 * $(window).width();
      //   const minVideoWidth = 0.4 * $(window).width();
      //   $('#primary').resizable('option', 'maxWidth', maxVideoWidth);
      //   $('#primary').resizable('option', 'minWidth', minVideoWidth);

      // 引数を0にすると、zoom倍率を変更せずに、幅を調節する
      this.zoomWaveSurfer(0);
    });

    // propsの変数のうち、フォームに設定する項目
    if (this.glossaryId) {
      this.form.glossaryId = this.glossaryId;
    }
    if (this.aimodelId) {
      this.form.aimodelId = this.aimodelId;
    }
    if (this.srcLanguageCode) {
      this.form.srcLanguageCode = this.srcLanguageCode;
    }
    if (this.trgLanguageCode) {
      this.form.trgLanguageCode = this.trgLanguageCode;
    } else if (!this.isShowCreate) {
      this.form.trgLanguageCode = '';
    }

    if (this.aimodels) {
      this.formAimodels = this.aimodels;
    }

    if (this.glossaries) {
      this.formGlossaries = this.glossaries;
    }

    video.onwaiting = () => {
      this.video.pause(); // 動画を一時停止する
    };

    for (let lang of this.$refs.trgLanguage) {
      if (lang.value === '中' || lang.value === '韓') {
        lang.disabled = true;
      }
    }

    if (!this.prohibitEdit) {
      window.addEventListener('beforeunload', this.leaveEditPage);
      window.addEventListener('onpopstate', this.leaveEditPage);
      window.addEventListener('unload', this.discardEdit);
    }

    // 字幕設定モーダルの初期設定
    this.modalTitleSetting.srcVisibility = this.subtitleSetting.srcVisibility;
    this.modalTitleSetting.trgPosition = this.subtitleSetting.trgPosition;
  },
  unmounted() {
    if (!this.prohibitEdit) {
      window.removeEventListener("beforeunload", this.leaveEditPage);
      window.removeEventListener('onpopstate', this.leaveEditPage);
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}


#primary,
.ui-resizable {
  max-height: 26rem;
  flex-grow: 1;
  max-width: 40%;
  background-color: black;
  min-height: 40%;
  min-width: 40%;
}

#video {
  max-height: 22rem;
  max-width: 100%;
  height: v-bind(videoHeight);
  /* width: v-bind(videoWidth); */
}

/* 1000px付近からデザインが崩れたのでデザインを変更。実装時点でのスマホ画面でのユーズケースは無し */
@media screen and (max-width: 1000px) {
  #flex-container{
    flex-direction: column;
  }
  #video{
    max-height: 18rem;
  }
}

#secondary {
  flex-grow: 1;
  max-height: 26rem;
  overflow: auto;
}

.div__waveform {
  /* padding-top: 2rem; */
}

.border {
  width: 50%;
  position: relative;
  border: none;
}

.div__caption--header {
  background-color: rgb(158, 158, 159);

}

.more__icon {
  float: right;
  margin-right: 0.5rem;
  transform: rotate(90deg);
  margin-top: 0.25rem;
}

.selected__div {
  background-color: rgb(252, 237, 176);
}


.number {
  background-color: rgba(36, 30, 28);
  color: white;
  border-radius: 5px;
  text-align: center;
  width: 100%;
  margin-bottom: 0;
  overflow: hidden;
  white-space: nowrap;
}

.div__Numbering::-webkit-scrollbar {
  display: none;
}

.filelabel {
  width: 40%;
  background: #b1b0b0;
  color: #fff;
  font-size: 1em;
  text-align: center;
  padding: 5px 10px;
}



.lang-pair-select::-ms-expand {
  display: none;
  /* デフォルトの矢印を無効(IE用) */
}

.lang-pair-select {
  -webkit-appearance: none;
  appearance: none;
  /* デフォルトの矢印を無効 */
  color: #999;
  font-size: 1rem;
  padding: 0.4rem 2.4rem 0.4rem 0.4rem;

  background-image: url(/img/16_tri.svg);
  background-repeat: no-repeat;
  background-size: 1.3rem;
  background-position: right 0.2rem center;

  border: 1px solid #ced4da;
  border-radius: 0.2rem;
}

.select_pair_arrow {
  width: 2rem !important;
  height: 2rem !important;
  margin: 0 0.5rem;
}

.input__number {
  background-color: rgb(100, 99, 100);
  /* 背景色を黒に設定 */
  color: white;
  /* 文字色を白に設定 */
  font-size: 12px;
  /* フォントサイズを設定 */
  width: 20px;
  /* 幅を指定 */
  text-align: center;
  /* 文字を中央揃えにする */
  border: none;
  border-radius: 2px;
  padding: 0;
  /* border-color: rgb(100, 99, 100); */
}

.input__number:focus,
.textarea__caption:focus,
.textarea__caption {
  outline: none;
  border-radius: 0;
}

.no-spin::-webkit-inner-spin-button,
.no-spin::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
  -moz-appearance: textfield;

}

.no-spin {
  -moz-appearance: textfield;
}

.container-fluid {
  padding-top: 3rem;
  min-height: calc(100vh - 1.8rem);
}
</style>

<style>
.ui-resizable-se {
  /* display: none !important; */
}

#waveform ::part(region-handle-left) {
  border-left-width: 2px !important;
  border-left-color: #ff0000 !important;
}
</style>
